import React, { useEffect, useRef, useState } from 'react';

const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

const loadLeaflet = () => new Promise((resolve, reject) => {
  if (window.L) { resolve(window.L); return; }
  if (!document.querySelector('link[href*="leaflet.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = LEAFLET_CSS;
    document.head.appendChild(link);
  }
  const existing = document.querySelector('script[src*="leaflet.js"]');
  if (existing) {
    existing.addEventListener('load', () => resolve(window.L));
    existing.addEventListener('error', reject);
    return;
  }
  const script = document.createElement('script');
  script.src = LEAFLET_JS;
  script.async = true;
  script.onload = () => resolve(window.L);
  script.onerror = () => reject(new Error('Falha ao carregar o mapa'));
  document.body.appendChild(script);
});

export default function GpsMap({ person, lat, lng }) {
  const [failed, setFailed] = useState(false);
  const mapRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadLeaflet().then((L) => {
      if (cancelled || mapRef.current) return;
      const map = L.map('result-gps-map').setView([lat, lng], 19);
      const satellite = L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        { maxZoom: 21, maxNativeZoom: 18, attribution: 'Imagens &copy; Esri' }
      );
      const osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 21,
        maxNativeZoom: 19,
        attribution: '&copy; OpenStreetMap',
      });
      const labels = L.tileLayer(
        'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
        { maxZoom: 21, maxNativeZoom: 18 }
      );
      satellite.addTo(map);
      L.control.layers(
        { 'Satélite': satellite, 'Mapa': osm },
        { 'Rótulos de ruas': labels },
        { position: 'topright' }
      ).addTo(map);

      const pin = L.divIcon({
        className: '',
        html:
          '<div style="width:30px;height:30px;background:#F47729;border:3px solid #fff;'
          + 'border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 8px rgba(0,0,0,.45);'
          + 'display:flex;align-items:center;justify-content:center">'
          + '<span style="transform:rotate(45deg);color:#fff;font-size:13px;font-weight:700">&#10013;</span></div>',
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -28],
      });
      L.marker([lat, lng], { icon: pin })
        .addTo(map)
        .bindPopup(
          `<strong>Jazigo ${person.number}</strong><br/>Quadra ${person.block}`
          + `${person.sector ? ` — Setor ${person.sector}` : ''}`
        )
        .openPopup();
      mapRef.current = map;
      setTimeout(() => { if (!cancelled) map.invalidateSize(); }, 200);
    }).catch(() => {
      if (!cancelled) setFailed(true);
    });
    return () => {
      cancelled = true;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng]);

  const accuracy = person.gps_accuracy_m != null ? Math.round(person.gps_accuracy_m) : null;

  return (
    <div className="map-container">
      <div className="map-header">
        <h3>
          Mapa do Cemitério
          <span className="badge badge-info" style={{ marginLeft: 10, verticalAlign: 'middle' }}>GPS</span>
        </h3>
      </div>
      <div className="map-canvas">
        {failed ? (
          <div className="map-load-error">
            <p>Não foi possível carregar o mapa. Verifique sua conexão.</p>
            <p style={{ fontSize: 12, marginTop: 6 }}>
              Coordenada: {lat.toFixed(6)}, {lng.toFixed(6)}
            </p>
          </div>
        ) : (
          <div id="result-gps-map" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }} />
        )}
      </div>
      <div className="map-legend">
        <div className="legend-item">
          <div className="legend-dot gps"></div>
          <span>Jazigo {person.number} — Quadra {person.block}{person.sector ? ` / Setor ${person.sector}` : ''}</span>
        </div>
        {accuracy != null && (
          <div className="legend-item">
            <span>Precisão GPS: {accuracy} m</span>
          </div>
        )}
      </div>
    </div>
  );
}
